function ozeaOpenClaimFromHash() {
  var hash = window.location.hash;
  if (!hash) return;
  var target = document.querySelector(hash);
  if (target && target.tagName === 'DETAILS') {
    target.open = true;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a.ozea-footnote').forEach(function (link) {
    link.addEventListener('click', function () {
      window.setTimeout(ozeaOpenClaimFromHash, 0);
    });
  });
});

window.addEventListener('hashchange', ozeaOpenClaimFromHash);
